import { useTranslation } from 'react-i18next';
import {
  DeleteOutlined,
  ExclamationCircleOutlined,
  EyeOutlined,
  FileDoneOutlined,
  FormOutlined,
  MoreOutlined,
  SaveOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import {
  Button,
  Dropdown,
  Form,
  Layout,
  MenuProps,
  message,
  Modal,
  Popconfirm,
  Space,
  Switch,
  TableColumnsType,
  TableProps,
} from "antd";
import {get, isEmpty} from "lodash";
import React, {ChangeEvent, KeyboardEvent, useEffect, useState,} from "react";
import {useNavigate} from "react-router-dom";

import PageHeader from "../../components/page-header/PageHeader";
import FilterAdminInterface from "../../components/admin-interface/filter-table/FilterTable";
import {formatDateV2} from "../../utils/converDate";
import {routesConfig} from "../../config/routes";
import TableData from "../../components/table-data/TableData";
import FormFilter from "../../components/admin-interface/filter-group/FormFilter";
import {
  deleteCertificateTemplate,
  getListCertificate,
  postCopyCertificateTemplate,
  putUpdateCertificateTemplate,
} from "../../service/certificate";
import SaveTemplateCertificateDrawer from "../../components/drawer/certificate-save-template";
import { HelpService } from "../../service/helper.service";

type Props = {
  title?: string;
};

const CertificatePage = (props: Props) => {
  const { t } = useTranslation();
  const [tab, setTab] = useState("1");
  const {title} = props;
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const [listContentForum, setListContentForum] = useState<any>([]);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [clearRowkey, setClearRowkey] = useState<boolean>(false);
  const [clearFiltered, setClearFiltered] = useState<boolean>(false);

  const [pageSize, setPageSize] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [statusOrder, setStatusOrder] = useState<string>("");
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("");
  const [dataUpdate, setDataUpdate] = useState<any>();
  const [lastPreview, setlastPreview] = useState<any>(null);
  const [mode, setMode] = useState<string>("");
  const [isOpenedSaveTemplate, setIsOpenedSaveTemplate] =
    useState<boolean>(false);

  const [filterData, setFilterData] = useState<any>({
    status: null,
    approvedDate: null,
  });

  const navigate = useNavigate();
  const [form] = Form.useForm();
  const handleOpenCreate = () => {
    setIsOpened(true);
    setDataUpdate({});
  };

  const helpService = new HelpService();

  const optionsContentForum1: MenuProps["items"] = [
    {
      key: "1",
      label: t("Xem chi tiết", "Xem chi tiết"),
      icon: <FileDoneOutlined/>,
    },
    {
      key: "2",
      label: t("Lưu mẫu", "Lưu mẫu"),
      icon: <SaveOutlined/>,
    },
    {
      key: "3",
      label: t("Tạo bản nháp", "Tạo bản nháp"),
      icon: <FormOutlined/>,
    },
    {
      key: "4",
      label: t("Cài đặt hoạt động", "Cài đặt hoạt động"),
      icon: <SettingOutlined/>,
    },
    {
      key: "5",
      label: t("Xóa", "Xóa"),
      icon: <DeleteOutlined/>,
      danger: true,
    },
  ];

  const getListData = async (reset?:boolean) => {
    let resetPage = 1
    if(reset) {
      setPageNumber(1)
    }
    setLoading(true);
    const data = {
      page: reset ? resetPage : pageNumber,
      size: pageSize,
      keyword: searchValue.trim() || undefined,
      createdDateFrom:
        !isEmpty(filterData.approvedDate) &&
        !isEmpty(filterData.approvedDate?.[0])
          ? `${filterData.approvedDate?.[0]}T00:00:00.000Z`
          : null,
      createdDateTo:
        !isEmpty(filterData.approvedDate) &&
        !isEmpty(filterData.approvedDate?.[1])
          ? `${filterData.approvedDate?.[1]}T00:00:00.000Z`
          : null,
      status: filterData.status ?? null,
      sort: statusOrder ? [`${fieldSortOrder},${statusOrder}`] : [],
      sortByView: lastPreview && lastPreview === 1 ? "desc" : null,
      sortByLastDiscussDate: lastPreview && lastPreview === 2 ? "desc" : null,
    };

    await getListCertificate(data)
      .then((res) => {
        const {data} = res.data;
        setListContentForum(data.templates);
        setTotalRecords(data.total);
        setTimeout(() => {
          setLoading(false);
        }, 500);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getListData();
  }, [tab, pageNumber, pageSize, statusOrder, lastPreview, clearFiltered]);

  const handleOpenFilter = () => {
    setShowFilter((showFilter) => !showFilter);
  };

  const handleSubmitSearch = () => {
    getListData(true);
  };

  const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      getListData(true);
    }
  };

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const {value} = e.target;
    setSearchValue(value);
  };

  const handleCloseFilter = () => {
    setShowFilter(false);
  };

  const handleDuplicateTemplate = async (id: string) => {
    setLoading(true);
    await postCopyCertificateTemplate(id)
      .then((result: any) => {
        setLoading(false);
        message.success(t("Lưu thông tin thành công", "Lưu thông tin thành công"));
        getListData();
      })
      .catch((err: any) => {
        setLoading(false);
        console.error(err);
      });
  };

  const handleDeleteTemplate = async (id: string) => {
    setLoading(true);
    await deleteCertificateTemplate(id)
      .then((result: any) => {
        setLoading(false);
        message.success(t("Lưu thông tin thành công", "Lưu thông tin thành công"));
        getListData();
      })
      .catch((err: any) => {
        setLoading(false);
        console.error(err);
      });
  };

  //

  const renderStatus = (value: number) => {
    switch (value) {
      case 0:
        return <p>{t("Nháp", "Nháp")}</p>;
      case 1:
        return <p>{t("Áp dụng", "Áp dụng")}</p>;
      default:
        break;
    }
  };

  const postContentBlog = async (id: string | undefined) => {
    // await publishTopic(id).then((res) => {
    //   if (res.status === 200) {
    //     message.success(t("Đăng bài thành công", "Đăng bài thành công"))
    //     getListData()
    //   }
    // })
  };

  const clearFilter = () => {
    // setLoading(true)
    form.resetFields();
    setFilterData({
      status: null,
      courseType: null,
      approvedDate: null,
    });
    setClearFiltered(false)
  };

  const dataColumns: TableColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "numericalOrder",
      key: "numericalOrder",
      width: 10,
      render: (_: any, record, index: number) => {
        return <div>{record?.numericalOrder}</div>;
      },
    },
    {
      title: t("Tên mẫu", "Tên mẫu"),
      dataIndex: "name",
      key: "name",
      sorter: true,
      width: 30,
      render: (_: any, record, index: number) => {
        return <div dangerouslySetInnerHTML={{__html: record?.name}}></div>;
      },
    },
    {
      title: t("Ngày tạo", "Ngày tạo"),
      dataIndex: "createdDate",
      key: "createdDate",
      width: 20,
      render: (_: any, record) => {
        return (
          <>{record?.createdDate ? formatDateV2(record?.createdDate) : null}</>
        );
      },
    },
    {
      title: t("Mã mẫu", "Mã mẫu"),
      dataIndex: "sampleCode",
      key: "sampleCode",
      width: 20,
      render: (_: any, record) => {
        return (
          <span className="p-3 rounded-full px-1.5 py-0.5">
            {record?.sampleCode}
          </span>
        );
      },
    },
    {
      title: t("Trạng thái", "Trạng thái"),
      dataIndex: "status",
      key: "status",
      shouldCellUpdate(record, prevRecord) {
        return true;
      },
      width: 20,
      render: (_: any, record: { id: number, status: boolean }) => {
        // const handleChange = (checked: boolean) => {
        //   record.status = checked;
        //   console.log('wtf')
        // };

        const confirm = (id: number) => {
          const dataSent = {
            status: record.status ? 0 : 1,
          };

          putUpdateCertificateTemplate(dataSent, record?.id).then((res) => {
            if (res.status === 200) {
              helpService.successMessage(
                `${
                  record?.status ? t("Áp dụng", "Áp dụng") : t("Hủy áp dụng", "Hủy áp dụng")
                } ` + t("chứng nhận / chứng chỉ thành công", "chứng nhận / chứng chỉ thành công")
              );
              getListData();
            }
          });
        };

        const cancel = () => {
        };

        return (
          <Popconfirm
            description={`${t("Bạn có chắc chắn muốn", "Bạn có chắc chắn muốn")} ${record.status ? t("hủy áp dụng", "hủy áp dụng") : t("áp dụng", "áp dụng")} ${t("chứng nhận / chứng chỉ?", "chứng nhận / chứng chỉ?")}`}
            onConfirm={() => {
              confirm(get(record, "id"));
            }}
            onCancel={cancel}
            okText={t("Xác nhận", "Xác nhận")}
            cancelText={t("Huỷ", "Huỷ")}
            title=""
          >
            <Switch
              defaultChecked={record.status}
              checked={record.status}
              // onChange={handleChange}
            />
          </Popconfirm>
        );
      },
    },
    {
      title: "",
      dataIndex: "action",
      fixed: "right",
      key: "operation",
      render: (_, record) => {
        const location = {
          id: `${record.id}`,
        };
        return (
          <>
            <Space>
              <a
                className="action-table"
                onClick={() => {
                  window.open(
                    routesConfig.certificate +
                    routesConfig.certificatePageViewer +
                    "/" +
                    record.id,
                    "_blank",
                    "noreferrer"
                  );
                }}
              >
                <EyeOutlined/>
              </a>

              <Dropdown
                menu={{
                  items: optionsContentForum1,
                  onClick: ({key}) => {
                    if (key === "1") {
                      navigate(`${record?.id}`, {
                        state: {
                          ...record,
                          isCourseEvaluation: true,
                          mode: "view",
                          name: record?.name,
                          detailData: record,
                        },
                      });
                    }

                    if (key === "2") {
                      setIsOpenedSaveTemplate(true);
                      setDataUpdate(record);
                      setMode("");
                    }

                    if (key === "3") {
                      Modal.confirm({
                        title: t("Xác nhận tạo bản nháp", "Xác nhận tạo bản nháp"),
                        content: t("Vui lòng xác nhận tạo bản nháp mẫu chứng nhận/chứng chỉ", "Vui lòng xác nhận tạo bản nháp mẫu chứng nhận/chứng chỉ"),
                        onOk: () => {
                          handleDuplicateTemplate(record?.id);
                        },
                        okText: t("Xác nhận", "Xác nhận"),
                        cancelText: t("Huỷ", "Huỷ"),
                        centered: true,
                        icon: (
                          <ExclamationCircleOutlined
                            style={{color: "#1677FF"}}
                          />
                        ),
                        footer: (_, {OkBtn, CancelBtn}) => (
                          <>
                            <CancelBtn/>
                            <OkBtn/>
                          </>
                        ),
                      });
                    }

                    if (key === "4") {
                      navigate(`${routesConfig.certificate}/${record.id}`, {
                        state: {tab: "2"},
                      });
                    }

                    if (key === "5") {
                      Modal.confirm({
                        title: t("Xác nhận xóa", "Xác nhận xóa"),
                        content: t("Mẫu chứng nhận/chứng chỉ đã xóa sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá chứng nhận/chứng chỉ này?", "Mẫu chứng nhận/chứng chỉ đã xóa sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá chứng nhận/chứng chỉ này?"),
                        onOk: () => {
                          handleDeleteTemplate(record?.id);
                        },
                        okText: t("Xác nhận", "Xác nhận"),
                        cancelText: t("Huỷ", "Huỷ"),
                        centered: true,
                        icon: (
                          <ExclamationCircleOutlined
                            style={{color: "#1677FF"}}
                          />
                        ),
                        footer: (_, {OkBtn, CancelBtn}) => (
                          <>
                            <CancelBtn/>
                            <OkBtn/>
                          </>
                        ),
                      });
                    }
                  },
                }}
                placement="bottomRight"
              >
                <Button>
                  <MoreOutlined/>
                </Button>
              </Dropdown>
            </Space>
          </>
        );
      },
      width: 10,
    },
  ];

  const defaultCheckedList = dataColumns.map((item) => item.key as string);

  const [checkedList, setCheckedList] = useState(defaultCheckedList);

  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
          ? "desc"
          : "";
    setStatusOrder(data);
    setFieldSortOrder(sorter.field);
  };

  const listBreadcrumb = [
    {
      title: t("Quản trị cơ sở", "Quản trị cơ sở"),
    },
  ];

  const handleChangeFilter = (value: any, name: string) => {
    setFilterData({...filterData, [name]: value});
  };

  return (
    <Layout className="page-header-group course-evaluation">
      <Form.Provider
        onFormFinish={(name, {values, forms}) => {
          if (name === "filterForm") {
            setClearFiltered(true)
          }
        }}
      >
        <div
          className={`page-header-group--layout ${
            showFilter ? "open-filter" : ""
          }`}
        >
          <div className="table-header--wrapper">
            <div className="table-header--left">
              <PageHeader title={title} listBreadcrumb={listBreadcrumb}/>
            </div>
            <FilterAdminInterface
              handleOpen={handleOpenCreate}
              searchValue={searchValue}
              dataColumns={dataColumns}
              handleOpenFilter={handleOpenFilter}
              handleSubmitSearch={handleSubmitSearch}
              handleSearch={handleSearch}
              checkedList={checkedList}
              setCheckedList={setCheckedList}
              handleChangeInput={handleChangeInput}
              selectedRowKeys={selectedRowKeys}
              setlastPreview={setlastPreview}
              tab={tab}
            />
          </div>
          <FormFilter
            handleCloseFilter={handleCloseFilter}
            clearFilter={clearFilter}
            form={form}
            showFilter={showFilter}
            tab={tab}
            filterData={filterData}
            setFilterData={handleChangeFilter}
          />
        </div>
        <div className="tabs-heading">
          <div className="waiting-assignment">
            <TableData
              dataColumns={dataColumns}
              loadingTable={loading}
              dataTable={listContentForum}
              pageSize={pageSize}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              setPageSize={setPageSize}
              totalRecords={totalRecords}
              scroll={{x: 1500, y: 800}}
              pagination={true}
              hideSelection={false}
              handleTableChangeProps={handleTableChange}
              setSelectedRowKeysProps={setSelectedRowKeys}
              clearRowkey={clearRowkey}
            />
          </div>
        </div>
      </Form.Provider>
      <SaveTemplateCertificateDrawer
        open={isOpenedSaveTemplate}
        handleClose={() => setIsOpenedSaveTemplate(false)}
        getListData={getListData}
        tab={tab}
        mode={mode}
        dataUpdate={dataUpdate}
      />
    </Layout>
  );
};

export default CertificatePage;
